// src/utils/storage.ts

export type MessageType = 'text' | 'file';
export type MessageContentType = 'user' | 'ai';

export interface ChatMessage {
    text: string;
    sender: MessageContentType;
    time: string;
    file: File | null;
    fileType: string;
    msgType: MessageType;
}

export function saveMessageToSessionStorage(
    msgType: MessageType,
    text: string,
    sender: MessageContentType,
    time: string,
    file: File | null,
    fileType: string
) {
    const messages: ChatMessage[] = JSON.parse(sessionStorage.getItem('chatMessages') || '[]');
    const newMessage: ChatMessage = { text, sender, time, file, fileType, msgType };
    messages.push(newMessage);
    sessionStorage.setItem('chatMessages', JSON.stringify(messages));
}
